// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/wing-blank/style/index.less
// module id = 215
// module chunks = 0